import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from '@core/utility/utility.service';
import { ENV } from '@env/environment';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, FacebookAuthProvider, getAuth, GithubAuthProvider, GoogleAuthProvider, OAuthProvider,TwitterAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    public http:HttpClient,
    public utilService:UtilityService
  ) {
  }

  app= initializeApp(ENV.firebase.config)
  auth = (()=>{
    let auth = getAuth(this.app)
    if(["DEV","TEST","DOCKER_DEV"].includes(ENV.type)){
      connectAuthEmulator(auth, `http://${ENV.firebase.config.authDomain}:9093`,{disableWarnings:true})
    }
    auth.useDeviceLanguage()
    return auth
  })();
  googleProvider = new GoogleAuthProvider();
  facebookProvider = new FacebookAuthProvider();
  yahooProvider = new OAuthProvider('yahoo.com');
  microsoftProvider  =  new OAuthProvider('microsoft.com')
  githubProvider = new GithubAuthProvider();
  twitterProvider = new TwitterAuthProvider()
  appleProvider =(()=>{
    let provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    return provider
  })()
  idpInfo = {
    GOOGLE:{
      provider:this.googleProvider,
      AuthProvider:GoogleAuthProvider
    },
    FACEBOOK:{
      provider:this.facebookProvider,
      AuthProvider:FacebookAuthProvider
    },
    YAHOO:{
      provider:this.yahooProvider,
      AuthProvider: OAuthProvider
    },
    MICROSOFT:{
      provider:this.microsoftProvider,
      AuthProvider: OAuthProvider
    },
    GITHUB:{
      provider:this.githubProvider,
      AuthProvider:GithubAuthProvider
    },
    TWITTER:{
      provider:this.twitterProvider,
      AuthProvider:TwitterAuthProvider
    },
    APPLE:{
      provider:this.appleProvider,
      AuthProvider:OAuthProvider
    }

  }
  analytics =(()=>{
    return getAnalytics(this.app)
  })()

}
